export default __webpack_public_path__ + "static/image14-194ddad266aa7c071c5ec7725438ea78.gif";